import { version } from '../../package.json'

export function equalStr (str1, str2) {
  return str1.toLowerCase() === str2.toLowerCase()
}

export function insertCss (filename, doc) {
  const tag = doc.createElement('link')
  const port = window.location.port ? `:${window.location.port}` : ''
  tag.type = 'text/css'
  tag.rel = 'stylesheet'
  tag.href = `//${document.domain}${port}/dist/${filename}.min.css?version=${version}`

  doc.head.appendChild(tag)
}

export function insertScriptTag (src, async = false, defer = false, integrity = null, crossorigin = null) {
  const tag = document.createElement('script')
  tag.setAttribute('src', src)
  if (async) tag.setAttribute('async', '')
  if (defer) tag.setAttribute('defer', '')
  if (integrity) tag.setAttribute('integrity', integrity)
  if (crossorigin) tag.setAttribute('crossorigin', crossorigin)
  document.body.appendChild(tag)
}

export function ready (fn) {
  if (document.readyState !== 'loading') {
    fn()
  } else {
    document.addEventListener('DOMContentLoaded', fn)
  }
}

export function isInViewport (elem) {
  const bounding = elem.getBoundingClientRect()

  return (
    bounding.top >= 0 &&
    bounding.left >= 0 &&
    bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
    bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
  )
}

export function equalizeHeight (elements, condition = () => true) {
  elements.forEach(e => { e.style.removeProperty('height') })
  if (condition(elements)) {
    const tallest = Math.max(...elements.map(e => e.clientHeight))
    elements.forEach(e => { e.style.height = tallest + 'px' })
  }
}

export function scrollTo (elem, offset = 0, event = null) {
  event && event.preventDefault()
  if (!isInViewport(elem)) {
    const y = elem.getBoundingClientRect().top + window.pageYOffset + offset
    window.scrollTo({ top: y, behavior: 'smooth' })
  }
}
